<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title> Body Measurements </mat-panel-title>
    <mat-panel-description>
      <!-- <img [src]="personal" /> -->
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="spinner" *ngIf="bodyMeasure === undefined">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
  <div class="expansion-content" *ngIf="bodyMeasure !== undefined">
    <div class="cell">
      <label>Weight : </label>
      <span>{{ bodyMeasure.weight }} KG</span>
    </div>
    <div class="cell">
      <label>Height : </label>
      <span>{{ bodyMeasure.height }} Feet</span>
    </div>
    <div class="cell">
      <label>Bust : </label>
      <span>{{ bodyMeasure.bust }} CM</span>
    </div>
    <div class="cell">
      <label>Hips : </label>
      <span>{{ bodyMeasure.hips }} CM</span>
    </div>
    <div class="cell">
      <label>Waist : </label>
      <span>{{ bodyMeasure.waist }} CM</span>
    </div>
  </div>
</mat-expansion-panel>
